export default __webpack_public_path__ + "static/media/Ass_5.24776230.svg";